<template>
  <div :class="_.block">
    <div :class="[_.list, _._hairlineBottom]">
      <div v-if="order.orderNo" :class="_.item">
        <div>订单编号：</div>
        <div>{{ order.orderNo }}</div>
        <button
          v-track="{
            name: '我的订单-订单编号-复制',
            id: 'f19aad96-6170-4717-acbe-fc577452fb22',
          }"
          @click="handleCopyClick"
        >
          复制
        </button>
      </div>
      <div v-if="order.payType" :class="_.item">
        <div>支付方式：</div>
        <div>{{ order.payType }}</div>
      </div>
      <div v-if="order.paySerialNo" :class="_.item">
        <div>支付编号：</div>
        <div>{{ order.paySerialNo }}</div>
      </div>
      <div v-if="order.orderTime" :class="_.item">
        <div>下单时间：</div>
        <div>{{ order.orderTime }}</div>
      </div>
      <div v-if="order.closeTime" :class="_.item">
        <div>关闭时间：</div>
        <div>{{ order.closeTime }}</div>
      </div>
      <div v-if="order.payTime" :class="_.item">
        <div>付款时间：</div>
        <div>{{ order.payTime }}</div>
      </div>
      <div v-if="order.shipTime" :class="_.item">
        <div>发货时间：</div>
        <div>{{ order.shipTime }}</div>
      </div>
      <div v-if="order.dealTime" :class="_.item">
        <div>成交时间：</div>
        <div>{{ order.dealTime }}</div>
      </div>
      <div :class="_.item">
        <div v-html="'备　　注：'"></div>
        <div>{{ order.remark || '无' }}</div>
      </div>
    </div>
    <div :class="_.actions">
      <div
        v-if="order.merchantTel"
        v-track="{
          name: '我的订单-联系商家',
          id: '79006049-c968-441f-a92d-66e52ce6dd0b',
        }"
        :class="_.item"
        @click="handleContactMartClick"
      >
        <img :src="require('./images/联系商家.png')" :class="_.icon" />
        联系商家
      </div>
      <div
        v-track="{
          name: '我的订单-平台客服',
          id: '17250617-5574-49d4-9d7c-7b96270ebb33',
        }"
        :class="_.item"
        @click="handleContactPlatformClick"
      >
        <img :src="require('./images/平台客服.png')" :class="_.icon" />
        平台客服
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { copyTextToClipboard } from 'vtils'
  import { dcb } from '@dcb/jssdk'
  import { Toast } from 'vant'

  export default Vue.extend({
    props: {
      order: {
        type: Object,
        required: true,
      },
    },

    methods: {
      handleCopyClick() {
        copyTextToClipboard(this.order.orderNo)
        Toast.success('复制成功')
      },

      handleContactMartClick() {
        dcb.makePhoneCall({
          phoneNumber: this.order.merchantTel,
        })
      },

      handleContactPlatformClick() {
        dcb.makeCustomerServicePhoneCall()
      },
    },
  })
</script>

<style lang="scss" module>
  .block {
    background: #ffffff;
    border-radius: 8px;
    margin-top: 12px;
    padding: 12px;
  }

  .list {
    padding-bottom: 12px;

    .item {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #222222;
      line-height: 17px;

      div:first-child {
        flex-shrink: 0;
      }

      button {
        background: #fff3f2;
        border-radius: 8px;
        font-size: 11px;
        color: #ff202a;
        line-height: 16px;
        border: none;
        padding: 1px 5px;
        margin-left: 8px;
      }

      &:not(:first-child) {
        margin-top: 12px;
      }
    }
  }

  .actions {
    display: flex;
    align-items: center;
    padding-top: 12px;

    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #222222;
      line-height: 20px;

      .icon {
        width: 16px;
        height: 17px;
        margin-right: 8px;
      }

      &:not(:first-child) {
        border-left: 1px solid #e0e0e0;
      }
    }
  }
</style>
